import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AccountService } from './api/account.service';
import { BackofficeAccountService } from './api/backofficeAccount.service';
import { BackofficeBrandsService } from './api/backofficeBrands.service';
import { BackofficeDocumentsService } from './api/backofficeDocuments.service';
import { ContactsService } from './api/contacts.service';
import { DictionaryService } from './api/dictionary.service';
import { FileService } from './api/file.service';
import { GoldfingerService } from './api/goldfinger.service';
import { MailingService } from './api/mailing.service';
import { MyLibraryService } from './api/myLibrary.service';
import { SecurityService } from './api/security.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AccountService,
    BackofficeAccountService,
    BackofficeBrandsService,
    BackofficeDocumentsService,
    ContactsService,
    DictionaryService,
    FileService,
    GoldfingerService,
    MailingService,
    MyLibraryService,
    SecurityService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
